import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import Modal from '~/components/Modal/Modal';
import { CustomerListMatchingAttribute } from '~/types/api.graphql';
import { getMatchingAttributeLabel } from '~/utils/customerListMatchingRules';

import { WarningText } from './MatchingRulesField.styles';

interface ProfileAttributeWarningProps {
  columnName: string;
  attribute: CustomerListMatchingAttribute;
  onConfirm: () => void;
  onCancel: () => void;
}

/** A column ticked in the simple view with a profile attribute, which alone matches many people per row */
const ProfileAttributeWarning = ({
  columnName,
  attribute,
  onConfirm,
  onCancel,
}: ProfileAttributeWarningProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Modal
      open
      width="26rem"
      title={t('aiInsights.a2ui.matchingRules.profileAttributeWarning.title', {
        attribute: getMatchingAttributeLabel(attribute),
      })}
      submitButtonTitle={t('aiInsights.a2ui.matchingRules.profileAttributeWarning.confirm')}
      onSubmit={onConfirm}
      onClose={onCancel}
    >
      <WarningText>
        <Trans
          i18nKey="aiInsights.a2ui.matchingRules.profileAttributeWarning.body"
          values={{ attribute: getMatchingAttributeLabel(attribute), column: columnName }}
          // The column name is the file's own text; React escapes it, so i18next mustn't as well
          tOptions={{ interpolation: { escapeValue: false } }}
          components={{ bold: <strong /> }}
        />
      </WarningText>
    </Modal>
  );
};

export default ProfileAttributeWarning;
